/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type OverviewTabEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const overviewTabEntryPoint: EntryPoint<OverviewTabEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<OverviewTabEntryPointComponent>(
			/* webpackChunkName: "async-prevention-center-overview-tab" */ './OverviewTab.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => ({}),
	});
